import { parseFormatSetValue } from "@garimpa/lib/parseFormatSetValue";

export function normalizeFormatSetSelection(
  previousValues: readonly string[],
  nextValues: readonly string[],
): string[] {
  const addedValue = nextValues.find((value) => !previousValues.includes(value));
  const addedItem = addedValue ? parseFormatSetValue(addedValue) : null;
  if (!addedValue || !addedItem) return [...nextValues];

  return nextValues.filter((value) => {
    if (value === addedValue) return true;
    return parseFormatSetValue(value)?.format !== addedItem.format;
  });
}
